// extracted by mini-css-extract-plugin
export default {"wrapper":"notFound_wrapper__XwF0E","fadeIn":"notFound_fadeIn__gDTGD"};